import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrGet26asDetailsInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-file-pdf', title: 'ITR Get 26AS Details', subtitle: 'Fetch Form 26AS details for an ITR client' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'itr_xxxxxxxxxxxxx', maxLength: 100, mono: true },
            { name: 'tds_id', label: 'TDS ID', icon: 'pi-hashtag', placeholder: 'TDS request ID', maxLength: 100, mono: true },
        ]}
        endpoint={{
            method: 'GET',
            path: '/surepass/itr/get-26as-details',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), tds_id: v.tds_id.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-get-26as-details"
        submitLabel="Fetch 26AS Details"
        successSummary="26AS details fetched"
        errorSummary="26AS fetch failed"
        confirmHeader="Confirm 26AS details fetch"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'ITR Form 26AS Details', icon: 'pi-file-pdf' }}
    />
);

export default ItrGet26asDetailsInputComponent;
